import Menu from './Compartido/Menu.jsx';
import Footer from './Compartido/Footer.jsx';
import TextoArmadores from './Armadores/TextoArmadores.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Armadores = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Armadores-y-Agencias"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextoArmadores
                lang={props.lang}
                armadores={props.textopropietarios}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Armadores;

